export default "__VITE_ASSET__lLikK2g8__"